import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import cn from 'clsx';
import {device} from '@guestapp/ui/src/utils/device';
import {usePath, useScreenResize} from 'hooks';
import {PATHS} from 'Routes';
import Page from 'components/Page';
import {PaymentSummaryBox} from '../../components/PaymentSummaryBox';
import styles from './styles.module.css';

function BeforeYouLeaveView() {
  const {t} = useTranslation('check-out');
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {isMatch: isMobile} = useScreenResize(device.tabletSubHeader);
  // const {data: summary} = useSummary(); //TODO: VERSION 2
  // const showMozio =
  //   summary?.mozio_status === OFFER_STATUSES.active && !ChekinProSettings.isSDK;

  return (
    <Page
      className="!mb-[155px] md:!mb-6 checkout-view"
      navBarTitle={t('check_out_short')}
      mainHeader={!isMobile}
      isSubHeaderVisible
      onBackButtonClick={() => {
        navigate(getFullPath(PATHS.home));
      }}
    >
      <div
        className={cn(styles.checkoutView__container, 'checkout-view__container w-full')}
      >
        {/* {showMozio && ( //TODO: VERSION 2
          <div className="w-full checkout-view__container-left">
            <div
              color={finalTheme.colors.branding.fontPrimary}
              className="text-lg font-semibold leading-6 tracking-wide"
            >
              {t('before_you_leave')}
            </div>
            <div>
              <div
                color={finalTheme.colors.branding.fontSecondary}
                className="text-sm font-normal leading-6 tracking-wide"
              >
                {t('before_you_leave_subtitle')}
              </div>

              <div className="flex flex-col gap-6">
                <CheckoutPaymentCartBox
                  title={t('airport_city_transfers')}
                  price={'$100'}
                  description={t('before_you_leave_subtitle')}
                  icon={<Clock4Icon size={20} />}
                  inCheckout={false}
                />
              </div>
            </div>
          </div>
        )} */}
        <div className="w-full checkout-view__container-right">
          <PaymentSummaryBox />
        </div>
      </div>
    </Page>
  );
}

export default BeforeYouLeaveView;
